import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListModelCell } from './charge-point-list-model.cell';
import { ChargePointListModelHeader } from './charge-point-list-model.header';

export const ChargePointListModelColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['model']
> = {
  enableSorting: false,
  header: ChargePointListModelHeader,
  cell: ChargePointListModelCell,
  meta: { maxWidth: '140px' },
};
